// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app,.pult-app-content{height:100%}.ant-input-number-handler-wrap{display:none!important}", ""]);
// Exports
module.exports = exports;
